import React from 'react';
import { CellProps } from '../types';
import * as Styled from '../styles';

export const DefaultCell = ({ val }: CellProps) => (
  <Styled.CellStyled>
    {val}
  </Styled.CellStyled>
);
